import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: styledHeaderText(t("newLayer.dialogHeader", { ns: "dialogs" })),
        icon: "layers",
      },
      meta: {
        aliasLabel: t("newLayer.layerName", { ns: "dialogs" }),
        descriptionLabel: t("newLayer.layerDescription", { ns: "dialogs" }),
        loaderLabel: t("newLayer.imageForCatalog", { ns: "dialogs" }),
      },
      applyText: t("actions.create", { ns: "common" }),
      attributes: {
        label: t("newLayer.attributes", { ns: "dialogs" }),
        description: t("newLayer.attributesHint", { ns: "dialogs" }),
        icon: "data",
        addAttribute: t("newLayer.userAttribute", { ns: "dialogs" }),
      },
    }),
    [t],
  );
};
